// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "desktopinputs_boxdash__y83iu";
var _3 = "desktopinputs_boxpath__fb27t";
var _4 = "desktopinputs_buttonswrapper__lkrbk";
var _5 = "desktopinputs_cancel__bplsq";
var _6 = "desktopinputs_content__svzya";
var _7 = "desktopinputs_contentwrapper__et4ox";
var _8 = "640px";
var _9 = "790px";
var _a = "#057676";
var _b = "desktopinputs_disableanimation__n89uy";
var _c = "desktopinputs_disabled__w3ett";
var _d = "desktopinputs_forceshow__atawz";
var _e = "#434343";
var _f = "desktopinputs_hidden__0ts1a";
var _10 = "desktopinputs_inputs__929ru";
var _11 = "79px";
var _12 = "110px";
var _13 = "72px";
var _14 = "665px";
var _15 = "desktopinputs_outline__y9+lx";
var _16 = "desktopinputs_refresh__8xigy";
var _17 = "teal";
var _18 = "2";
var _19 = "#cdd3dc";
var _1a = "desktopinputs_validation__t0rks";
export { _1 as "body", _2 as "boxDash", _3 as "boxPath", _4 as "buttonsWrapper", _5 as "cancel", _6 as "content", _7 as "contentWrapper", _8 as "controlsMobileWidth", _9 as "controlsStackedWidth", _a as "darkTeal", _b as "disableAnimation", _c as "disabled", _d as "forceShow", _e as "headline", _f as "hidden", _10 as "inputs", _11 as "menuHeight", _12 as "menuHeightLarge", _13 as "menuHeightMobile", _14 as "modalMobileWidth", _15 as "outline", _16 as "refresh", _17 as "teal", _18 as "timelineStrokeWidth", _19 as "timelineTrackColor", _1a as "validation" }
